// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface EnvironmentList
 */
export interface EnvironmentList {
  /**
   *
   * @type {Array<string>}
   * @memberof EnvironmentList
   */
  items?: Array<string>;
}

/**
 * Check if a given object implements the EnvironmentList interface.
 */
export function instanceOfEnvironmentList(
  value: object,
): value is EnvironmentList {
  return true;
}

export function EnvironmentListFromJSON(json: any): EnvironmentList {
  return EnvironmentListFromJSONTyped(json, false);
}

export function EnvironmentListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvironmentList {
  if (json == null) {
    return json;
  }
  return {
    items: json['items'] == null ? undefined : json['items'],
  };
}

export function EnvironmentListToJSON(json: any): EnvironmentList {
  return EnvironmentListToJSONTyped(json, false);
}

export function EnvironmentListToJSONTyped(
  value?: EnvironmentList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items: value['items'],
  };
}
